module.exports = __webpack_public_path__ + "img/legend-seq.a2c27e42.svg";